// extracted by mini-css-extract-plugin
export default {"rating":"Ez-z","numberOfStars":"Fz-z","count":"Gz-z","barGraphSpacing":"Hz-z","barGraph":"Iz-z"};